import React from 'react';
import ReactEcharts from 'echarts-for-react';

const Jcline = ({ data }) => {
  // Month number to name mapping
  const monthMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
  };

  // Financial year order (Apr → Mar)
  const financialOrder = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];

  // Map data
  const monthValueMap = {};
  if (Array.isArray(data)) {
    data.forEach((item) => {
      const monthName = monthMap[item.key] || item.key;
      monthValueMap[monthName] = item.doc_count;
    });
  }

  // Always show 12 months
  const xData = financialOrder;
  const yData = financialOrder.map((m) => monthValueMap[m] ?? 0);

  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#fff',
      borderColor: '#ccc',
      borderWidth: 1,
      textStyle: { color: '#333' },
    },
    grid: {
      left: '4%',
      right: '4%',
      bottom: '10%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: xData,
      boundaryGap: false,
      axisLine: { lineStyle: { color: '#ccc' } },
      axisLabel: {
        color: '#333',
        interval: 0, // ✅ show every label
        rotate: 0, // optional: set 45 if labels overlap
      },
      splitLine: { show: false },
    },
    yAxis: {
      type: 'value',
      splitLine: { show: false },
      axisLine: { lineStyle: { color: '#ccc' } },
      axisLabel: { color: '#333' },
    },
    series: [
      {
        data: yData,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        itemStyle: {
          color: '#4A90E2',
        },
        lineStyle: {
          width: 2,
          color: '#4A90E2',
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(74,144,226,0.4)' },
              { offset: 1, color: 'rgba(74,144,226,0.05)' },
            ],
          },
        },
      },
    ],
  };

  return (
    <div>
      <ReactEcharts
        option={option}
        style={{
          width: '100%',
          height: 320,
          marginLeft: '3px',
          marginTop: '4px',
        }}
      />
    </div>
  );
};

export default Jcline;
